import { css, SerializedStyles } from '@emotion/core';
import styled from '@emotion/styled';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import { ICustomTheme } from 'interfaces';

export const cssArrowDown = (theme: ICustomTheme): SerializedStyles =>
  css({
    position: 'relative',
    top: 3,
    color: theme.colors.paletteFromBO.main,
  });

export const cssPosition = (theme: ICustomTheme): SerializedStyles =>
  css({
    color: theme.colors.paletteFromBO.main,
  });

const iconStyle = () => ({
  fontSize: 26,
  color: 'inherit',
});

export const ArrowDownIcon = styled(ExpandLessIcon)(iconStyle);

export const ArrowUpIcon = styled(ExpandMoreIcon)(iconStyle);
